import gql from 'graphql-tag';

export const InboxQuery = gql`
    query inboxQuery($page: Int!, $pageSize: Int!) {
        inbox(page: $page, pageSize: $pageSize) {
            conversations {
                conversationID
                correspondents {
                    avatar
                    name
                }
                displayCurrentState
                displayLastMessageDate
                displayLocation
                displayStayDates
                messageText
                totalGuests
                unreadMessages
            }
            page
            pageSize
            totalResults
        }
    }
`;
